export const UPDATE_TOKEN = 'UPDATE_TOKEN'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const INSPECT_TOKEN = 'INSPECT_TOKEN'
export const REGISTER = 'REGISTER'
export const LOGOUT = 'LOGOUT'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const VERIFY_FORGOT_PASSWORD_TOKEN = 'VERIFY_FORGOT_PASSWORD_TOKEN'
export const RESET_PASSWORD = 'RESET_PASSWORD'

export const GET_USER = 'GET_USER'
export const GET_CHILDREN = 'GET_CHILDREN'
export const CREATE_CHILD = 'CREATE_CHILD'
export const UPDATE_CHILD = 'UPDATE_CHILD'
export const DELETE_CHILD = 'DELETE_CHILD'

export const CREATE_MESSAGE = 'CREATE_MESSAGE'

export const GET_HOLIDAYS = 'GET_HOLIDAYS'
export const GET_HOLIDAYS_SECTION_CAPACITY = 'GET_HOLIDAYS_SECTION_CAPACITY'
export const SET_CAPACITY_LOADING = 'SET_CAPACITY_LOADING'
export const CREATE_REGISTRATION = 'CREATE_REGISTRATION'
export const GET_REGISTRATIONS = 'GET_REGISTRATIONS'

export const GET_CONTENTS = 'GET_CONTENTS'

export const GET_SECTIONS = 'GET_SECTIONS'

export const GET_TEAM_MEMBERS = 'GET_TEAM_MEMBERS'

export const GET_NEWS = 'GET_NEWS'

export const GET_CHILD_SECTION = 'GET_CHILD_SECTION'
